<div class="col-md-12">
  <div class="logo-container">
    <img id="logo-img" alt="N5X Logo" src="../../assets/logo_n5x.png" class="logo-img-card">
    <h1 id="head-title" class="head-title">
      N5X Developer Portal
    </h1>
  </div>
  <div class="card card-container">
    @if (!isLoggedIn) {
    <form
      name="form"
      (ngSubmit)="f.form.valid && onSubmit()"
      #f="ngForm"
      novalidate
    >
      <div class="form-group">
        <label for="username">Usuário</label>
        <input
          type="text"
          class="form-control"
          name="username"
          [(ngModel)]="form.username"
          required
          #username="ngModel"
          [ngClass]="{ 'is-invalid': f.submitted && username.errors }"
        />
        @if (username.errors && f.submitted) {
        <div class="invalid-feedback">Usuário é obrigatório!</div>
        }
      </div>
      <div class="form-group">
        <label for="password">Senha</label>
        <input
          type="password"
          class="form-control"
          name="password"
          [(ngModel)]="form.password"
          required
          minlength="6"
          #password="ngModel"
          [ngClass]="{ 'is-invalid': f.submitted && password.errors }"
        />
        @if (password.errors && f.submitted) {
        <div class="invalid-feedback">
          @if (password.errors['required']) {
          <div>Senha é obrigatória</div>
          }
          @if (password.errors['minlength']) {
          <div>Senha deve ter ao menos 6 caracteres</div>
          }
        </div>
        }
      </div>
      <div class="form-group">
        <button class="btn btn-primary btn-block">Login</button>
      </div>
      <div class="form-group">
        @if (f.submitted && isLoginFailed) {
        <div class="alert alert-danger" role="alert">
          Falha no login: {{ errorMessage }}
        </div>
        }
      </div>
    </form>
    } @else {
    <div class="alert alert-success">Autenticado com sucesso!</div>
    }
  </div>
</div>
